const data = {};

/**
 * 유저 정보
 *  status
 *  -1	신청전	등록되지 않은 사용자
 *  0	신청	서류대기
 *  1	처리중	전자결재 상신
 *  2	승인	정보변경 완료
 *  3	반려	처리불가
 */

data.mypageInfo = {
  data: {
    code: 0,
    message: 'success',
    data: {
      isFirst: false,
      isBusinessFirst: true,
      isCheckedIdNo: true,
      isRemainPoint: true,
      businessType: 1,
      telNo: null,
      zipCode: null,
      address1: null,
      address2: null,
      userName: '김*영',
      businessName: null,
      businessLicenseNumber: null,
      businessEmail: null,
      // status: -2, // 개인사용자
      // status: -1, // 신청전
      // status: 0, // 신청
      // status: 1, // 처리중
      status: 2, // 승인
      // status: 3, // 반려
      // status: 99, // 에러
      bankName: '이전통장은행',
      accountNo: '이전통장번호',
      accountOwnerName: '이전통장',
    },
    // "data":{
    //   "isFirst": true,
    //   "isBusinessFirst": true,
    //   "isCheckedIdNo": false,
    //   "isRemainPoint": false,
    //   "businessType": 0,
    //   "telNo": null,
    //   "zipCode": null,
    //   "address1": null,
    //   "address2": null,
    //   "userName": "김*영",
    //   "businessName": null,
    //   "businessLicenseNumber": null,
    //   "businessEmail": null,
    //   "status": -1,
    //   "bankName": null,
    //   "accountNo": null,
    //   "accountOwnerName": null,
    // }
    // "data":{
    //   "isFirst": true,
    //   "isBusinessFirst": true,
    //   "isCheckedIdNo": false,
    //   "isRemainPoint": true,
    //   "businessType": 3,
    //   "telNo": "010-1234-5678",
    //   "zipCode": "우편번호",
    //   "address1": "주소1(도로명 및 번지)",
    //   "address2": "주소2(상세주소)",
    //   "userName": "이름",
    //   "businessName": "업체(법인)명",
    //   "businessLicenseNumber": "010-1234-5678",
    //   "businessEmail": "adasdasdasd@asdasdasd.com",
    //   "bankName": "은행명",
    //   "accountNo": "계좌번호",
    //   "accountOwnerName": "계좌주",
    //   "status": 2
    // }
  },
};

data.registryMypage = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.modifyContact = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.modifyBusinessTelno = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.modifyBusinessEmail = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.modifyAccount = {
  data: {
    code: 0,
    message: 'success',
    data: {
      bankCode: '101',
      accountNo: '123***123',
    },
    debug: null,
  },
};

data.modifyBusinessAccount = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.mypagehistory = {
  data: {
    code: 0,
    message: 'success',
    data: {
      list: [
        {
          applyType: 1, // 1: 유형 변경, 2: 정보 변경
          businessType: 3,
          zipCode: '우편번호',
          address1: '주소1(도로명 및 번지)',
          address2: '주소2(상세주소)',
          businessName: '업체(법인)명1',
          businessLicenseNumber: '사업자 등록번호',
          businessOwnerName: '계좌주',
          status: 2,
          bankName: '은행명',
          accountNo: '계좌번호',
          accountOwnerName: '계좌주 명',
          reqDate: '신청날짜',
          updateDate: '처리일',
        },
        {
          applyType: 2,
          businessType: 2,
          zipCode: '우편번호',
          address1: '주소1(도로명 및 번지)',
          address2: '주소2(상세주소)',
          businessName: '업체(법인)명2',
          businessLicenseNumber: '사업자 등록번호',
          businessOwnerName: '계좌주',
          status: 3,
          bankName: '은행명',
          accountNo: '계좌번호',
          accountOwnerName: '계좌주 명',
          reqDate: '신청날짜',
          updateDate: '처리일',
          reason: '사유',
        },
      ],
    },
  },
};
data.delWithdrawalInfo = {
  data: {
    "code" : 0,
    "message" : "success",
    "data" : null,
    "debug" : null
  }
}

export default {
  ...data,
};
